import { HI_PATIENT_IDENTITY_AGENCY_VALIDATE_ROLES } from '../patient-identity/access';

/** Batch HI.12 validation uses the same agency validation role cohort as H06/H07. */
export const HI_PATIENT_IDENTITY_BATCH_ROLES = HI_PATIENT_IDENTITY_AGENCY_VALIDATE_ROLES;

export type HiPatientIdentityBatchRole = (typeof HI_PATIENT_IDENTITY_BATCH_ROLES)[number];

export function canRunHiPatientIdentityBatch(role: string): role is HiPatientIdentityBatchRole {
  return (HI_PATIENT_IDENTITY_BATCH_ROLES as readonly string[]).includes(role);
}
